export default __webpack_public_path__ + "static/media/img1.be244db6.svg";